import React from "react";
import { brands } from "../../mock/mock";

export default function Brands() {
  const doubled = [...brands, ...brands];
  return (
    <section className="relative py-16 md:py-20 border-t border-white/5 overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 mb-8">
        <div className="flex items-end justify-between gap-6">
          <div className="section-label">Brands I've Worked With</div>
          <span className="mono text-[11px] tracking-[0.2em] uppercase text-[var(--muted)] hidden sm:block">
            40+ &mdash; across India
          </span>
        </div>
      </div>

      <div className="marquee relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 z-10 bg-gradient-to-r from-[var(--bg)] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 z-10 bg-gradient-to-l from-[var(--bg)] to-transparent" />

        <div className="marquee-track gap-10 md:gap-16 px-6 md:px-10">
          {doubled.map((b, i) => (
            <div key={`${b}-${i}`} className="shrink-0 flex items-center gap-4 group">
              <span className="h-2 w-2 rounded-full bg-[var(--sage)]/70 group-hover:scale-125 transition-transform" />
              <span className="font-display text-3xl md:text-4xl text-[var(--text-dim)] group-hover:text-[var(--text)] transition-colors whitespace-nowrap">
                {b}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
